import * as React from 'react';
import GroupOptionsCheckbox from './GroupOptionsCheckbox';

import { Mutation } from 'react-apollo';
import SET_CLASS_VISIBILITY from 'groups/components/mutations/setClassVisibility.gql';
import ToastActions from 'actions/ToastActions';
import { ApolloError } from 'apollo-client';
import { setClassVisibilityVariables } from 'groups/components/mutations/__generated__/setClassVisibility';

type Props = {
  checked: boolean;
  classSearchabilitySchoolDefault: string;
  searchable: boolean; // old
  classSearchabilityFeatureEnabled: boolean; // new
  onChange: (event: React.MouseEvent, setClassVisibility?: any) => void;
};

const GroupOptionsClassSearchabilityCheckbox = (props: Props) => {
  if (props.classSearchabilityFeatureEnabled) {
    // new (nov 2019): updates searchability only. messageability handled in <GroupOptionsParticipantMessagingSelect />
    return (
      <Mutation
        mutation={SET_CLASS_VISIBILITY}
        onCompleted={() => ToastActions.showSuccessToast('Saved')}
        onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
        {(setClassVisibility: (input: { variables: setClassVisibilityVariables }) => void) => (
          <GroupOptionsCheckbox
            label="Class visibility"
            sublabel="This class will appear in class search and on your profile."
            checked={props.checked}
            schoolDefault={props.classSearchabilitySchoolDefault}
            onChange={event => props.onChange(event, setClassVisibility)}
          />
        )}
      </Mutation>
    );
  } else {
    // old: updates searchability and messageability together
    return (
      <GroupOptionsCheckbox
        label="People in this class can see and message each other"
        sublabel="If you select this option, people at your school can also find your class."
        checked={props.checked}
        onChange={event => props.onChange(event)}
      />
    );
  }
};

export default GroupOptionsClassSearchabilityCheckbox;
